module.exports = require("url-loader");